import React, {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  ReactNode,
} from 'react';

import { Spinner } from 'components';

export interface ButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  isLoading?: boolean;
  title?: string;
  spinnerColor?: string;
  className?: string;
  children?: ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  isLoading,
  className,
  title,
  spinnerColor,
  children,
  ...other
}) => {
  return (
    <button disabled={isLoading} className={`p-2 ${className}`} {...other}>
      {isLoading ? (
        <Spinner fill={spinnerColor} className="w-4 h-5" />
      ) : children ? (
        children
      ) : (
        title
      )}
    </button>
  );
};

export default Button;
